import { useEffect } from 'react';
import './styles/App.scss';
import { Routes, Route } from 'react-router-dom';
import Control from './screens/Control';
import Dataview from './screens/Dataview';
import Overview from './screens/Overview';
import Sensors from './screens/Sensors';
import Manual from './screens/Manual';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import ConfigForm from './screens/ConfigForm';
import { loginRequest } from "./authConfig";
import { useAppDispatch } from './hooks';
import { getConfig } from './features/Sensors/ConfigSlice';
import "leaflet/dist/leaflet.css";


export default function App() {
  const Login = () => {
    const { instance, accounts } = useMsal();

    useEffect(() => {

      instance.loginRedirect(loginRequest).catch(e => {
      });
    }, [])
    return (
      <div>Redirecting for login</div>
    )
  };
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch({ type: 'ssestream/connect', payload: "measurements/getMeasurements" })
    dispatch({ type: 'ssestream/connect', payload: "settings/waypoint" })
    dispatch({ type: 'ssestream/connect', payload: "settings/motd" })
    dispatch({ type: 'ssestream/connect', payload: "projects/getActiveProject" })
    dispatch({ type: 'ssestream/connect', payload: "phases/getActivePhase" })
    dispatch({ type: 'ssestream/connect', payload: "ping" })
    dispatch(getConfig());
  }, []);

  const { instance, accounts } = useMsal();

  return (
    <>
      {process.env.REACT_APP_AUTH_TYPE == "Microsoft" ?
        <>

          <AuthenticatedTemplate>
              <div id='app_container' className='app relative'>
                <Routes>
                  <Route path="/" element={<Overview kiosk={false} />} />
                  <Route path="/kiosk" element={<Overview kiosk={true} />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/control" element={<Control />} />
                  <Route path="/dataview" element={<Dataview />} />
                  <Route path="/overview" element={<Overview kiosk={false} />} />
                  <Route path="/sensors" element={<Sensors />} />
                  <Route path="/config-form" element={<ConfigForm />} />
                  <Route path="/manual" element={<Manual />} />
                </Routes>
              </div>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Login />
          </UnauthenticatedTemplate>
        </>
        :
        <>
          <div id='app_container' className='app relative'>
            <Routes>
              <Route path="/" element={<Overview kiosk={false} />} />
              <Route path="/kiosk" element={<Overview kiosk={true} />} />
              <Route path="/login" element={<Login />} />
              <Route path="/control" element={<Control />} />
              <Route path="/dataview" element={<Dataview />} />
              <Route path="/overview" element={<Overview kiosk={false} />} />
              <Route path="/sensors" element={<Sensors />} />
              <Route path="/config-form" element={<ConfigForm />} />
              <Route path="/manual" element={<Manual />} />
            </Routes>
          </div>
        </>}
    </>

  );
}